// TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses.
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SportsBetDisplayDirective } from "@sports-directives/bet-display/bet-display";

@Component({
  selector: "sports-group",
  templateUrl: "./sports-group.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SportsBetDisplayDirective],
  styleUrls: ["./sports-group.component.scss"],
  //   host: {
  //     class: "background-color-button",
  //   },
})
export class SportsGroupComponent implements AfterViewInit {
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Input() sixPack = false;
  @Input() betType: string;
  // @Input() event: any;
  // @HostBinding ({ hostPropertyName?: string | undefined; });
  // @HostBinding("class.has-one-groups")
  // get groupsNumber() {
  //   return this.event?.Games?.length===1;
  // }
  // @HostBinding("class.teams-mode") get isSuccess() {
  //   return this.event?.mode === "teams";
  // }

  // @HostBinding("class.has-one-groups")
  // get groupsNumber() {
  //   return this.event?.Games?.length;
  // }
  // private cuotaEspecial = inject(ElementRef);
  // private _renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    // if (this.sportHandler === SportHandleList.apuestas_especiales) {
    //   // verificamos si tiene hermanos, es decir, si hay más botones
    //   if (this.cuotaEspecial.nativeElement.nextElementSibling !== null) {
    //     this._renderer.addClass(this.cuotaEspecial.nativeElement, "cuota-especial-25");
    //   } else {
    //     // no tiene hermanos
    //     this._renderer.addClass(this.cuotaEspecial.nativeElement, "cuota-especial-100");
    //   }
    // }
  }
  @HostListener("click")
  onBet() {
    this.clicked.emit();
  }
}
